import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  PATCH: 'STUDENT_COURSE_REVERT_UPGRADE_PAYMENT_LINK_PATCH',
  PATCH_SUCCESS: 'STUDENT_COURSE_REVERT_UPGRADE_PAYMENT_LINK_PATCH_SUCCESS',
  PATCH_FAILURE: 'STUDENT_COURSE_REVERT_UPGRADE_PAYMENT_LINK_FAILURE',
};

export const patch = actions.patch(id => `${BASE_URL}/student-course-upgrade/${id}`, {
  PENDING: ACTIONS.PATCH,
  SUCCESS: ACTIONS.PATCH_SUCCESS,
  FAILURE: ACTIONS.PATCH_FAILURE,
});
